import TjenestepanelCoreCms from '@helsenorge/core-cms/tjenestepanel-v2';
import type {
  AuthenticatedTiles,
  AuthenticatedFavoriteTiles,
} from '@helsenorge/core-cms/types/entities/helsenorge.corefrontend.internalapi.entities';
import { getSidetittelId } from '@helsenorge/framework-utils/hn-page';

import enResources from '../../resources/HN.CoreFrontend.Web.Forside.en-GB.json';
import nbResources from '../../resources/HN.CoreFrontend.Web.Forside.nb-NO.json';
import seResources from '../../resources/HN.CoreFrontend.Web.Forside.se-NO.json';

interface TjenestepanelResources {
  tjenestepanelVisFlere: string;
  tjenestepanelVisFarre: string;
}

const getResources = (language: 'no' | 'en' | 'se'): TjenestepanelResources => {
  switch (language) {
    case 'no':
      return nbResources;
    case 'en':
      return enResources;
    case 'se':
      return seResources;
    default:
      return nbResources;
  }
};

interface Props {
  language: 'no' | 'en' | 'se';
  favorites: AuthenticatedFavoriteTiles[] | null;
  groups: AuthenticatedTiles[] | null;
}

const Tjenestepanel: React.FunctionComponent<Props> = (props: Props) => {
  const resources = getResources(props.language);

  return (
    <TjenestepanelCoreCms
      titleId={getSidetittelId()}
      showMore={resources.tjenestepanelVisFlere}
      showLess={resources.tjenestepanelVisFarre}
      favorites={props.favorites}
      groups={props.groups}
    />
  );
};

export default Tjenestepanel;
